import { YapilyInstitution } from 'data/Payments/BankTransfer/types'
import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  img {
    width: 2rem;
  }
`

type Props = {
  className?: string
  institution: YapilyInstitution
  onClick: (institution: YapilyInstitution) => void
}
const Institution = ({ className, institution, onClick }: Props) => (
  <Wrapper className={className} onClick={() => onClick(institution)}>
    <img src={institution.media[0].source} />
    <span>{institution.fullName}</span>
  </Wrapper>
)

export default Institution
